import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IMigrateExampleAudioIdsResponse } from './migrate-example-audio-ids-response';
import { migrateExampleAudioIdsResponseSchema } from './migrate-example-audio-ids-response';

export async function migrateExampleAudioIdsApi(): Promise<
  IValidatedResponse<IMigrateExampleAudioIdsResponse>
> {
  return postRequest<IMigrateExampleAudioIdsResponse>({
    path: '/sys/challenges/audio/migrate-example-ids',
    schema: migrateExampleAudioIdsResponseSchema,
  });
}
